module.exports = __webpack_public_path__ + "img/debt.41e7a024.jpg";